/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Grid,
  ClickAwayListener,
  makeStyles,
  Typography,
} from '@material-ui/core';
import PageTitle from 'components/PageTitle';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Permission from 'components/ValidPermission';
import React from 'react';
import i18n from 'i18n';
import {
  deleteCustomRequest,
  getCustomStateRequest,
  getPartnerRequest,
} from 'modules/partners/actions';
import { CustomFields, PartnerFormFields } from 'modules/partners/interfaces';
import { useParams } from 'react-router';
import Loading from 'components/Loading';
import Button from 'components/Button';
import { ModalFields } from 'modules/modal/interfaces';
import { modalOpen, modalClose } from 'modules/modal/actions';
import { Formik, Form } from 'formik';
import VerificationCode from 'components/VerificationCode';
import styles from './FormCustom/styles';
import FormCustomFront from './FormCustom';

const useStyles = makeStyles(styles);

interface Props {
  customDetails: CustomFields | null;
  isLoading: boolean;
  isLoadingCustom: boolean;
  partner: PartnerFormFields | null;
  deleteCustomRequest: (props) => void;
  getCustomStateRequest: (id: string) => void;
  getPartnerRequest: (id: string) => void;
  modalClose: () => void;
  modalOpen: (props: ModalFields) => void;
}

const CustomPartnerFront = ({
  customDetails,
  isLoading,
  isLoadingCustom,
  partner,
  deleteCustomRequest,
  getCustomStateRequest,
  getPartnerRequest,
  modalClose,
  modalOpen,
}: Props) => {
  const [open, setOpen] = React.useState<boolean>(true);
  const { id } = useParams<{ id: string }>();
  const classes = useStyles();

  const [verificationCode, setVerificationCode] = React.useState<string[]>(
    Array(6).fill('')
  );

  const verificationCodeRef = React.useRef(verificationCode);

  React.useEffect(() => {
    verificationCodeRef.current = verificationCode;
  }, [verificationCode]);

  React.useEffect(() => {
    getCustomStateRequest(id);
  }, [id]);

  React.useEffect(() => {
    getPartnerRequest(id);
  }, [id]);

  const handleConfirm = () => {
    const verificationCodeToSend = verificationCodeRef.current;
    deleteCustomRequest({
      restricted_action_code: verificationCodeToSend.join(''),
      id,
    });
    modalClose();
  };

  const handleSubmit = () => {
    setVerificationCode(Array(6).fill(''));
    deleteCustomRequest({ id });
    modalOpen({
      title: i18n.t('VERIFICATION_CODE_KEY'),
      content: (
        <VerificationCode
          length={6}
          setVerificationCode={setVerificationCode}
          onRetry={() => {
            deleteCustomRequest({ id });
          }}
          onConfirm={() => {
            handleConfirm();
          }}
        />
      ),
      fullWidth: true,
    });
  };

  const handleDeleteCustom = () => {
    modalOpen({
      title: i18n.t('PARTNER_PAGE.DELETE_CUSTOM_MODAL_TITLE_KEY', {
        name: partner?.name,
      }),
      content: (
        <>
          <Formik
            initialValues={{}}
            enableReinitialize
            validateOnChange={true}
            onSubmit={handleSubmit}
          >
            {({ submitForm }) => {
              return (
                <React.Fragment>
                  <Form>
                    <Grid container>
                      <Grid item xs={12}></Grid>
                      <Grid container className={classes.deleteSubtextGrid}>
                        <Typography className={classes.deleteSubtext}>
                          <InfoOutlinedIcon
                            fontSize="small"
                            className={classes.warningIcon}
                          />
                          {i18n.t('PARTNER_PAGE.DELETE_CUSTOM_SUBTEXT_KEY')}
                        </Typography>
                      </Grid>

                      <Grid
                        container
                        justify="flex-end"
                        className={classes.deleteButtons}
                      >
                        <Button
                          submitButton
                          id="delete-button"
                          onClick={submitForm}
                          isLoading={isLoadingCustom || isLoading}
                          className={classes.deleteButton}
                        >
                          {i18n.t('PARTNER_PAGE.DELETE_CUSTOM_BUTTON_KEY')}
                        </Button>
                        <Button
                          id="cancel-button"
                          variant="outlined"
                          onClick={modalClose}
                        >
                          {i18n.t('CANCEL_KEY')}
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                </React.Fragment>
              );
            }}
          </Formik>
        </>
      ),
    });
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(!open)}>
      <Grid container>
        <Grid
          container
          xs={12}
          className={classes.titleText}
          justify="space-between"
        >
          <Grid item>
            <PageTitle
              title={i18n.t('GROUPS_PAGE.FRONTEND_CUSTOMIZATION_KEY')}
            />
          </Grid>
          <Grid item>
            <Permission value="delete_user_theme_config">
              <Button
                submitButton
                id="delete-button"
                onClick={handleDeleteCustom}
                className={classes.deleteButton}
              >
                {i18n.t('PARTNER_PAGE.DELETE_CUSTOM_BUTTON_KEY')}
              </Button>
            </Permission>
          </Grid>
        </Grid>
        {isLoadingCustom || isLoading ? (
          <Grid container className={classes.loadingContainer}>
            <Loading />
          </Grid>
        ) : (
          <FormCustomFront customDetails={customDetails} id={id} open={open} />
        )}
      </Grid>
    </ClickAwayListener>
  );
};

const mapStateToProps = ({
  partners: { isLoadingCustom, isLoading, partnerDetails, customDetails },
}: ApplicationState) => ({
  isLoadingCustom,
  customDetails,
  partner: partnerDetails,
  isLoading,
});

export default connect(mapStateToProps, {
  getCustomStateRequest,
  getPartnerRequest,
  deleteCustomRequest,
  modalOpen,
  modalClose,
})(CustomPartnerFront);
